export const MenuItems = [
  { id: "1", text: "Mеню", path: "menu", icon: "menu" },
  // { id: "2", text: "Слайдер", path: "carousel", icon: "file-image" },
  { id: "3", text: "Семейный", path: "family", icon: "file-image" },
  { id: "4", text: "Производство", path: "production", icon: "build" },
  { id: "5", text: "О Компании", path: "about", icon: "team" },
  { id: "6", text: "Продукты", path: "products", icon: "shop" },
  { id: "7", text: "Контакты", path: "contact", icon: "contacts" },
  { id: "8", text: "Футер", path: "footer", icon: "copyright" },
  { id: "9", text: "Выйти", path: "logout", icon: "logout" }
];
export const Items = {
  aboutItem: "aboutItem",
  aboutItemDescription: "aboutItemDescription",
  landing: "landing",
  menu: "menu",
  carousel: "carousel",
  family: "family",
  about: "about",
  categories: "categories",
  products: "products",
  contact: "contact",
  footer: "footer",
  sections: "sections",
  certificates: "certificates",
  production: 'production',
  production_doc: 'production_doc',
};
